// Match PHP trim's six ASCII characters; Unicode spaces remain custom text.
export function isUncustomizedBookingNote(value) {
  return value === null || (typeof value === 'string' &&
    value.split('').every(character => ' \t\n\r\0\v'.includes(character)))
}

// Include the complete CRM identity as well as clinic and doctor codes.
export function bookingNoteScope(params) {
  return JSON.stringify(Object.keys(params).sort().map(key => [key, params[key]]))
}
